/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getICD10Diagnoses } from 'app/entities/icd-10-diagnosis/icd-10-diagnosis.reducer';
import { getEntities as getTemplatePrescriptions } from 'app/entities/template-prescription/template-prescription.reducer';
import { createEntity, getEntity, reset, updateEntity } from './template-diagnosis.reducer';

export const TemplateDiagnosisUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const iCD10Diagnoses = useAppSelector(state => state.iCD10Diagnosis.entities);
  const templatePrescriptions = useAppSelector(state => state.templatePrescription.entities);
  const templateDiagnosisEntity = useAppSelector(state => state.templateDiagnosis.entity);
  const loading = useAppSelector(state => state.templateDiagnosis.loading);
  const updating = useAppSelector(state => state.templateDiagnosis.updating);
  const updateSuccess = useAppSelector(state => state.templateDiagnosis.updateSuccess);

  const handleClose = () => {
    navigate(`/template-diagnosis${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getICD10Diagnoses({}));
    dispatch(getTemplatePrescriptions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...templateDiagnosisEntity,
      ...values,
      icd10diagnosis: iCD10Diagnoses.find(it => it.id.toString() === values.icd10diagnosis?.toString()),
      prescription: templatePrescriptions.find(it => it.id.toString() === values.prescription?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...templateDiagnosisEntity,
          icd10diagnosis: templateDiagnosisEntity?.icd10diagnosis?.id,
          prescription: templateDiagnosisEntity?.prescription?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.templateDiagnosis.home.createOrEditLabel" data-cy="TemplateDiagnosisCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.templateDiagnosis.home.createOrEditLabel">Create or edit a TemplateDiagnosis</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="template-diagnosis-id"
                  label={translate('tinyMedicRestApp.templateDiagnosis.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.templateDiagnosis.snomedConceptId')}
                id="template-diagnosis-snomedConceptId"
                name="snomedConceptId"
                data-cy="snomedConceptId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateDiagnosis.snomedConceptText')}
                id="template-diagnosis-snomedConceptText"
                name="snomedConceptText"
                data-cy="snomedConceptText"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateDiagnosis.active')}
                id="template-diagnosis-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateDiagnosis.cursor')}
                id="template-diagnosis-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateDiagnosis.lastUpdated')}
                id="template-diagnosis-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateDiagnosis.microSec')}
                id="template-diagnosis-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.templateDiagnosis.timestampEntry')}
                id="template-diagnosis-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="template-diagnosis-icd10diagnosis"
                name="icd10diagnosis"
                data-cy="icd10diagnosis"
                label={translate('tinyMedicRestApp.templateDiagnosis.icd10diagnosis')}
                type="select"
                required
              >
                <option value="" key="0" />
                {iCD10Diagnoses
                  ? iCD10Diagnoses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="template-diagnosis-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.templateDiagnosis.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {templatePrescriptions
                  ? templatePrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/template-diagnosis" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TemplateDiagnosisUpdate;
